<template>
  <div class="search-results-page">
    <!-- 加载状态 -->
    <div v-if="loading" class="loading-state">
      <i class="el-icon-loading" style="font-size: 32px; color: #409EFF;"></i>
      <p>搜索中...</p>
    </div>
    
    <!-- 搜索结果 -->
    <div v-else class="results-container">
      <div class="results-header">
        <h2>搜索结果</h2>
        <p class="search-info">
          找到 <span class="highlight-count">{{ searchResults.length }}</span> 个相关文档
          <span class="search-keyword">关键词: "{{ searchKeyword }}"</span>
        </p>
      </div>
      
      <!-- 空状态 -->
      <div v-if="searchResults.length === 0" class="empty-state">
        <el-empty description="未找到相关文档">
          <p class="empty-tip">尝试使用不同的关键词或查看所有文档</p>
        </el-empty>
      </div>
      
      <!-- 结果列表 -->
      <div v-else class="results-list">
        <div 
          v-for="doc in searchResults" 
          :key="doc.documentId"
          class="result-card"
          @click="handleResultClick(doc)"
        >
          <div class="card-header">
            <h3 class="doc-title">
              <i class="el-icon-document"></i>
              <span v-html="highlightText(doc.title)"></span>
            </h3>
            <div class="doc-meta">
              <span v-if="doc.collectionName" class="meta-item">
                <i class="el-icon-folder"></i>
                {{ doc.collectionName }}
              </span>
              <span v-if="doc.categoryPath" class="meta-item category-path">
                <i class="el-icon-tickets"></i>
                {{ doc.categoryPath }}
              </span>
              <span v-else-if="doc.categoryName" class="meta-item">
                <i class="el-icon-tickets"></i>
                {{ doc.categoryName }}
              </span>
            </div>
          </div>
          
          <!-- 关键词标签 -->
          <!-- <div v-if="doc.keywords" class="doc-keywords">
            <span class="keywords-label">
              <i class="el-icon-price-tag"></i>
              关键词:
            </span>
            <el-tag
              v-for="(tag, index) in parseKeywords(doc.keywords)"
              :key="index"
              size="small"
              type="success"
              class="keyword-tag"
            >
              <span v-html="highlightText(tag)"></span>
            </el-tag>
          </div> -->
          
          <!-- 内容摘要 -->
          <div v-if="doc.contentSnippet" class="doc-snippet">
            <!-- <div class="snippet-label">内容摘要：</div> -->
            <div class="snippet-text" v-html="highlightText(doc.contentSnippet)"></div>
          </div>
          
          <div class="card-footer">
            <span class="update-time">
              <i class="el-icon-time"></i>
              更新于 {{ formatDate(doc.updateTime) }}
            </span>
            <el-button type="text" size="small">
              查看详情 <i class="el-icon-arrow-right"></i>
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchResults',
  props: {
    searchKeyword: {
      type: String,
      required: true
    },
    searchResults: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleResultClick(doc) {
      // 直接在新标签页打开文档，并传递定位信息
      const baseUrl = window.location.origin
      const url = `${baseUrl}/collections/${doc.collectionId}/doc/${doc.documentId}?highlight=doc-${doc.documentId}`
      window.open(url, '_blank')
    },
    
    // 解析关键词路径为标签数组
    parseKeywords(keywords) {
      if (!keywords || keywords.trim() === '') {
        return []
      }
      // 移除首尾的斜杠，然后按斜杠分割
      return keywords.replace(/^\/+|\/+$/g, '')
        .split('/')
        .filter(tag => tag.trim() !== '')
    },
    
    highlightText(text) {
      if (!this.searchKeyword.trim() || !text) {
        return text
      }
      const keyword = this.searchKeyword.trim()
      const regex = new RegExp(`(${keyword})`, 'gi')
      return text.replace(regex, '<strong class="text-highlight">$1</strong>')
    },
    
    formatDate(dateStr) {
      if (!dateStr) return '-'
      const date = new Date(dateStr)
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })
    }
  }
}
</script>

<style>
/* 全局样式，用于高亮 */
.text-highlight {
  color: #409EFF !important;
  font-weight: 600;
  font-style: normal;
}
</style>

<style scoped>
.search-results-page {
  height: 100%;
  background: #fff;
  overflow-y: auto;
}

.loading-state {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  color: #909399;
}

.results-container {
  padding: 20px;
  /* max-width: 1200px; */
  margin: 0 auto;
}

.results-header {
  background: #fff;
  padding: 24px 30px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
  margin-bottom: 20px;
}

.results-header h2 {
  margin: 0 0 12px 0;
  font-size: 24px;
  color: #303133;
}

.search-info {
  margin: 0;
  font-size: 14px;
  color: #606266;
}

.highlight-count {
  color: #409EFF;
  font-weight: 600;
  font-size: 16px;
}

.search-keyword {
  margin-left: 15px;
  color: #909399;
}

.empty-state {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
  padding: 60px 20px;
}

.empty-tip {
  margin-top: 10px;
  color: #909399;
  font-size: 14px;
}

.results-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.result-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
  padding: 24px;
  cursor: pointer;
  transition: all 0.3s;
  border: 1px solid transparent;
}

.result-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 20px rgba(0,0,0,0.12);
  border-color: #409EFF;
}

.card-header {
  margin-bottom: 12px;
}

.doc-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  margin: 0 0 10px 0;
}

.doc-title i {
  color: #409EFF;
  font-size: 20px;
}

.doc-meta {
  display: flex;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
  color: #909399;
}

.meta-item i {
  font-size: 14px;
}

.category-path {
  color: #67c23a;
  font-weight: 500;
}

.doc-keywords {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 0;
  border-radius: 4px;
  /* margin-bottom: 12px; */
  flex-wrap: wrap;
}

.keywords-label {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
  color: #67c23a;
  font-weight: 500;
}

.keywords-label i {
  font-size: 14px;
}

.keyword-tag {
  margin: 2px 0;
}

.keyword-tag ::v-deep .text-highlight {
  /* background: #67c23a;
  color: #fff; */
  font-size: bold;
}

.doc-snippet {
  margin-bottom: 12px;
  padding: 12px 0;
}

.snippet-label {
  font-size: 12px;
  color: #909399;
  margin-bottom: 6px;
}

.snippet-text {
  font-size: 14px;
  line-height: 1.8;
  color: #606266;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 12px;
  border-top: 1px solid #f0f2f5;
}

.update-time {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
  color: #909399;
}

.update-time i {
  font-size: 14px;
}

/* 高亮样式 */
.text-highlight {
  color: #409EFF !important;
  background: #ecf5ff;
  padding: 2px 6px;
  border-radius: 3px;
  font-weight: 600;
  font-style: normal;
}

/* 滚动条 */
.search-results-page::-webkit-scrollbar {
  width: 8px;
}

.search-results-page::-webkit-scrollbar-thumb {
  background: #d1dbe5;
  border-radius: 4px;
}

.search-results-page::-webkit-scrollbar-track {
  background: transparent;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .results-container {
    padding: 15px;
  }
  
  .results-header {
    padding: 20px;
    margin-bottom: 15px;
  }
  
  .results-header h2 {
    font-size: 20px;
  }
  
  .search-info {
    font-size: 13px;
  }
  
  .result-card {
    padding: 20px;
  }
  
  .doc-title {
    font-size: 16px;
  }
  
  .doc-meta {
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
  }
  
  .card-footer {
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
  }
}

@media (max-width: 480px) {
  .results-container {
    padding: 10px;
  }
  
  .results-header {
    padding: 15px;
    margin-bottom: 10px;
  }
  
  .results-header h2 {
    font-size: 18px;
  }
  
  .search-info {
    font-size: 12px;
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
  
  .result-card {
    padding: 15px;
  }
  
  .doc-title {
    font-size: 15px;
  }
  
  .doc-snippet {
    font-size: 13px;
  }
  
  .snippet-text {
    font-size: 13px;
  }
}
</style>

